export const SOON_TRAILS = [
  { key: "stairs", img: "/trails/midnattsoltrappa.webp", troll: "sol-sigrid" },
  { key: "farm", img: "/trails/agard.webp", troll: "jonsokdanseren" },
  { key: "forest", img: "/trails/skogstien.webp", troll: "myrmor" },
  { key: "sea", img: "/trails/havtrollruta.webp", troll: "kaptein-morgan" },
];

export const HERO_SLIDES = [{ key: "fjord", kind: "live" }, { key: "partner", kind: "partner" }, ...SOON_TRAILS.map((s) => ({ ...s, kind: "soon" }))];
